import { render, staticRenderFns } from "./IconSvgClowderLogo.vue?vue&type=template&id=31723d74&scoped=true&"
import script from "./IconSvgClowderLogo.vue?vue&type=script&lang=js&"
export * from "./IconSvgClowderLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31723d74",
  null
  
)

export default component.exports